var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "mainContainer",
      class: _vm.mainClassNames,
      style: _vm.recalculateSize(),
      attrs: { slot: "body" },
      slot: "body"
    },
    [
      _c(
        "div",
        { staticClass: "ym-store-finder-controls" },
        [
          _vm.apiStatus === "ready"
            ? _c(
                "div",
                { ref: "controlContainer", staticClass: "control-container" },
                [
                  _c("results-view", {
                    attrs: {
                      provider: _vm.modules.provider,
                      showWelcomeParts: _vm.showWelcomeParts
                    }
                  }),
                  _vm._v(" "),
                  _vm.isNotScrollable
                    ? _c("details-view", {
                        attrs: { provider: _vm.modules.provider }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("routing-view", {
                    ref: "routing",
                    attrs: { provider: _vm.modules.provider }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "map-container" },
                    [
                      _c("map-view", {
                        attrs: {
                          provider: _vm.modules.provider,
                          lat: _vm.lat,
                          lng: _vm.lng,
                          zoom: _vm.zoom,
                          bbox: _vm.bbox
                        }
                      }),
                      _vm._v(" "),
                      _vm.showWelcomeParts
                        ? _c(
                            "div",
                            { staticClass: "logo-carousel-container" },
                            [_c("logos-carousel")],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.apiStatus === "ready"
            ? _c("search-view", {
                ref: "search",
                attrs: { provider: _vm.modules.provider },
                on: { mounted: _vm.onSearchMount }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("localize-btn")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }